import type { ForjaProgressEvent } from '@mxa-argos/modules/forja/interfaces/forja-progress-event.interface';
import type { ForjaShellLogEvent } from '@mxa-argos/modules/forja/interfaces/forja-shell-log-event.interface';

const PROGRESS_EVENT = 'progress';
const SHELL_LOG_EVENT = 'shell-log';

export class ForjaEngineEvents extends EventTarget {
  emit(event: ForjaProgressEvent): void {
    this.dispatchEvent(new CustomEvent<ForjaProgressEvent>(PROGRESS_EVENT, { detail: event }));
  }

  onProgress(listener: (event: ForjaProgressEvent) => void): () => void {
    return this.listen(PROGRESS_EVENT, listener);
  }

  emitShellLog(event: ForjaShellLogEvent): void {
    this.dispatchEvent(new CustomEvent<ForjaShellLogEvent>(SHELL_LOG_EVENT, { detail: event }));
  }

  onShellLog(listener: (event: ForjaShellLogEvent) => void): () => void {
    return this.listen(SHELL_LOG_EVENT, listener);
  }

  private listen<EventDetail>(name: string, listener: (detail: EventDetail) => void): () => void {
    const handler = (event: Event) => {
      listener((event as CustomEvent<EventDetail>).detail);
    };

    this.addEventListener(name, handler);

    return () => this.removeEventListener(name, handler);
  }
}
